<script>
  export default {
    name: 'MagGroup',
    componentName: 'MagGroup',
    props: {
      labelWidth: String,
      label: {
        type: [String, Boolean],
        default: false,
      },
    },
    data() {
      return {
        append: false,
        prepend: false,
      }
    },
    methods: {
      setSlots() {
        this.append = this.$slots.append;
        this.prepend = this.$slots.prepend || this.label;
      },
    },
    computed: {
      parent() {
        let parent = this.$parent || this.$root;
        let name = parent.$options.componentName;
        while (parent && (!name || name !== 'MagForm')) {
          parent = parent.$parent;
          name = '';
          if (parent) {
            name = parent.$options.componentName;
          }
        }
        return parent ? parent : null;
      },
      class_main() {
        return {
          'mag-group--prepend': this.prepend,
          'mag-group--append': this.append,
        }
      },
      style_label() {
        let data = {};
        if (this.style_label_width) data.width = this.style_label_width;
        return data;
      },
      style_label_width() {
        if (this.labelWidth) return this.labelWidth;
        if (this.parent && this.parent.labelWidth) return this.parent.labelWidth;
        return '';
      },
      show_label() {
        let bool = false;
        if (this.label) bool = true;
        if (this.$slots.prepend) bool = true;
        return bool;
      }
    },
    watch: {},
    components: {},
    mounted() {
      this.setSlots();
    },
    updated() {
      this.setSlots();
    },
    destroyed() {
    },
  }
</script>
<style src="../style/mag-group.scss" lang="scss"></style>
<template>
  <div class="mag-group" :class="class_main">
    <div class="mag-group__prepend" v-if="show_label" :style="style_label">
      <slot name="prepend">
        <span>{{label}}</span>
      </slot>
    </div>
    <div class="mag-group__main">
      <slot></slot>
    </div>
    <div class="mag-group__append" v-if="$slots.append">
      <slot name="append"></slot>
    </div>
  </div>
</template>
